import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close(e) {
    this.element.remove()
  }
}
